import { Avatar, Grid } from "antd";
import { useTranslation } from "react-i18next";
import CSAvatar from "../../../../assets/images/content/cs_avatar.png";
import { P2, P3 } from "../../../../components/NormalFonts";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import { ChatBubbleProps } from "./data";
import styles from "./styles.module.scss";

const ChatBubble: React.FC<ChatBubbleProps> = ({ chat }) => {
  const { t } = useTranslation();
  const { toLocalTimezone } = useGetTimezone();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div
      className={`${
        chat.sender_type === "admin"
          ? styles.adminBubbleContainer
          : styles.userBubbleContainer
      }`}
    >
      <Avatar className={styles.avatar} src={CSAvatar} size={40} />
      <div className={styles.textWrapper}>
        <P3 color="var(--chat-text-sub)">{`${
          chat.sender_type === "admin" ? t("chatroom.sender.admin") : ""
        }  ${toLocalTimezone(chat.created_at)?.format("h:mm A")}`}</P3>
        <div className={styles.bubble}>
          <P2 color="var(--chat-text-content)">{chat.message}</P2>
        </div>
      </div>
    </div>
  );
};

export default ChatBubble;
